export default {
  Connexion: {
    en: "Login",
    fr: "Connexion",
  },
  Email: {
    en: "Email",
    fr: "Email",
  },
  "Mot de passe": {
    en: "Password",
    fr: "Mot de passe",
  },
  "Vous avez oublié votre mot de passe ?": {
    en: "Did you forget your password?",
    fr: "Vous avez oublié votre mot de passe ?",
  },
  "Vous êtes connecté avec succès": {
    en: "You are successfully connected",
    fr: "Vous êtes connecté avec succès",
  },
  "Email ou mot de passe incorrect": {
    en: "Invalid email or password",
    fr: "Email ou mot de passe incorrect",
  },
  // Reset Password translations
  "Bienvenue sur la plateforme": {
    en: "Welcome to the platform",
    fr: "Bienvenue sur la plateforme",
  },
  "Rentrez ici vos identifiants pour accéder à la plateforme": {
    en: "Enter your credentials here to access the platform",
    fr: "Rentrez ici vos identifiants pour accéder à la plateforme",
  },
  "Votre plate-forme de sensibilisation ludique. Apprenez, progressez et certifiez-vous !":
    {
      en: "Your fun awareness platform. Learn, progress and get certified!",
      fr: "Votre plate-forme de sensibilisation ludique. Apprenez, progressez et certifiez-vous !",
    },
  "Réinitialisation du mot de passe": {
    en: "Password Reset",
    fr: "Réinitialisation du mot de passe",
  },
  "Rentrez ici votre nouveau mot de passe": {
    en: "Enter your new password here",
    fr: "Rentrez ici votre nouveau mot de passe",
  },
  "Rentrez ici votre email afin de pouvoir réinitaliser votre mot de passe": {
    en: "Enter your email to reset your password",
    fr: "Rentrez ici votre email afin de pouvoir réinitaliser votre mot de passe",
  },
  "Vérifier le mot de passe": {
    en: "Verify password",
    fr: "Vérifier le mot de passe",
  },
  Réinitialiser: {
    en: "Reset",
    fr: "Réinitialiser",
  },
  "Se connecter": {
    en: "Sign in",
    fr: "Se connecter",
  },
  "Si l'email est correct, vous devriez recevoir un mail sous peu": {
    en: "If the email is correct, you should receive an email shortly",
    fr: "Si l'email est correct, vous devriez recevoir un mail sous peu",
  },
  "Impossible de demander la réinitialisation du mot de passe": {
    en: "Unable to request password reset",
    fr: "Impossible de demander la réinitialisation du mot de passe",
  },
  "Les mots de passe ne correspondent pas": {
    en: "Passwords do not match",
    fr: "Les mots de passe ne correspondent pas",
  },
  "Votre mot de passe a été changé avec succès": {
    en: "Your password has been changed successfully",
    fr: "Votre mot de passe a été changé avec succès",
  },
  "Impossible de changer votre mot de passe": {
    en: "Unable to change your password",
    fr: "Impossible de changer votre mot de passe",
  },
  // CampaignRegistration
  "Token d'inscription invalide ou expiré": {
    en: "Invalid or expired registration token",
    fr: "Token d'inscription invalide ou expiré",
  },
  "Le mot de passe doit contenir au moins 6 caractères": {
    en: "Password must be at least 6 characters long",
    fr: "Le mot de passe doit contenir au moins 6 caractères",
  },
  "Inscription réussie ! Vous pouvez maintenant vous connecter avec vos identifiants.": {
    en: "Registration successful! You can now log in with your credentials.",
    fr: "Inscription réussie ! Vous pouvez maintenant vous connecter avec vos identifiants.",
  },
  "Ce compte existe déjà. Veuillez vous connecter pour accéder à la campagne.": {
    en: "This account already exists. Please log in to access the campaign.",
    fr: "Ce compte existe déjà. Veuillez vous connecter pour accéder à la campagne.",
  },
  "Impossible de finaliser l'inscription": {
    en: "Unable to complete the registration",
    fr: "Impossible de finaliser l'inscription",
  },
  "Chargement des informations de campagne...": {
    en: "Loading campaign information...",
    fr: "Chargement des informations de campagne...",
  },
  "Token invalide": {
    en: "Invalid token",
    fr: "Token invalide",
  },
  "Le lien d'inscription est invalide ou a expiré.": {
    en: "The registration link is invalid or has expired.",
    fr: "Le lien d'inscription est invalide ou a expiré.",
  },
  "Inscription à la campagne": {
    en: "Campaign registration",
    fr: "Inscription à la campagne",
  },
  Prénom: {
    en: "First name",
    fr: "Prénom",
  },
  Nom: {
    en: "Last name",
    fr: "Nom",
  },
  "Email professionnel": {
    en: "Professional email",
    fr: "Email professionnel",
  },
  "Confirmer le mot de passe": {
    en: "Confirm password",
    fr: "Confirmer le mot de passe",
  },
  "Inscription en cours...": {
    en: "Registering...",
    fr: "Inscription en cours...",
  },
  "S'inscrire": {
    en: "Register",
    fr: "S'inscrire",
  },
};
